import React from "react";
import {t} from "../../../shared-services/translate";
import BottomDefaultNotification from "./Bottom.defaultNotification";

const BottomWCExplanation = () => {
  const name = "BottomWCExplanation";

  return <>
    <BottomDefaultNotification name={name}>
      {t("products.weight_control.explanation_pdp")}
    </BottomDefaultNotification>
  </>;
};

export default BottomWCExplanation;
